import React from 'react'

import { Box } from '@gousto-internal/citrus-react'

import OrderRecipe from 'routes/Account/AccountComponents/OrderRecipe'
import type { RecipeTile } from 'routes/Account/MyDeliveries/hooks/useRecommendedRecipes'

import css from './SeeMenuSection.css'

export const SeeMenuSection = ({ recipes }: { recipes: RecipeTile[] }) => (
  <Box className={css.container}>
    {recipes.map((recipe: RecipeTile) => (
      <OrderRecipe key={recipe.id} recipeTitle={recipe.name} recipeImage={recipe.imageUrl} />
    ))}
  </Box>
)
